import { DummyStore } from 'stores';

import { Report } from '../types/report.type';

export namespace ReportStore {
  export const report = new DummyStore<Report>();
}
